import { JourneyTripOption } from '../../lib/types/models/product/journey'
import {
  JourneyTripOptionInput,
  JourneyTripOptionRequest
} from '../../lib/types/models/product/journey-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createTripOptions = (data: JourneyTripOptionInput & { journeyId: number }) => {
  const { journeyId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.products.createTripOptions.url, { id: journeyId }))
    .post<JourneyTripOption[], JourneyTripOptionRequest>({
      mainTripId: rest.mainTrip.id,
      placeId: rest.place.id,
      secondaryTripIds: rest.secondaryTrips.map((trip) => trip.id)
    })
}
